import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { toggle, up, down } from 'slide-element';
import { NgxPermissionsService } from 'src/app/core/modules/permissions';
import { Permissions } from 'src/app/core/services/permissions';
import { TranslationModuleEnum } from 'src/app/utils/translation-modules.enum';

@Component({
  selector: "app-page-filters",
  templateUrl: "./page-filters.component.html",
  styleUrls: ["./page-filters.component.scss"],
})
export class PageFiltersComponent implements OnInit, OnChanges {
  translationModulesEnum = TranslationModuleEnum;

  @Input() titleTranslationKey: string = "";
  @Input() titleTranslationModuleEnum: any;

  @Input() addBtnLabelTranslationKey: string = "";
  @Input() addBtnLabelTranslationModuleEnum: any;

  @Input() ImportUsersBtnLabelTranslationKey: string = "";
  @Input() ImportUsersBtnLabelTranslationModuleEnum: any;

  @Input() assignedSwitchBtnLabelTranslationKey: string = "";
  @Input() assignedSwitchBtnLabelTranslationModule: any;

  @Input() switchBtnLabelTranslationKey: string = "";
  @Input() switchBtnLabelTranslationModule: any;

  @Input() searchPlaceHolderTranslationKey: string = "";
  @Input() searchPlaceHolderTranslationModule: any;

  @Input() seeBtnTitleTranslationKey: string = "";
  @Input() seeBtnTitleTranslationModule: any;

  @ViewChild("advanced_filter_content") advancedFilterContent: ElementRef<HTMLElement>;

  @HostListener("document:click", ["$event"]) onMouseEnter(evt: any) {
    if (!this.eRef.nativeElement.contains(evt.target)) {
      this.showDropDown = false;
    }
  }

  @Input() lang: string;

  @Input() disableSearchBtn: boolean = false;
  // search field properties
  @Input() hasSearch: boolean = true;
  @Input() searchValue: string;
  @Input() searchPlaceHolder: string;

  // switch button properties
  @Input() hasAssignedSwitch: boolean = false;
  @Input() assignedSwitchId: string;
  @Input() assignedSwitchLabel: string;
  @Input() assignedSwitchValue: boolean;

  //switch tasks & main tasks
  @Input() hasSwitchMainTasks: boolean = false;
  @Input() SwitchMainTasksLabel: string;
  @Input() SwitchMainTasksValue: boolean;


  // view mode properties
  @Input() hasListViewBtn: boolean = false;
  @Input() hasCardsViewBtn: boolean = false;
  @Input() hasTreeViewBtn: boolean = false;
  @Input() hasExpandTreeBtn: boolean = false;
  @Input() isTreeExpanded: boolean = false;
  @Input() hasMapViewBtn: boolean = false;
  @Input() hasCalendarViewBtn: boolean = false;
  @Input() hasImportUsersBtn:boolean = false
  @Input() viewMode: 'list' | 'cards' | 'tree' | 'map' | 'calendar' = 'list';

  // advanced filter properties
  @Input() hasAdvancedFilter: boolean = false;
  @Input() popupAdvancedFilter: boolean = false;
  @Input() hasClearBtn: boolean = true;
  @Input() clearBtnLabel: string;
  @Input() cancelBtnLabel: string;
  @Input() searchBtnLabel: string;
  @Input() appliedFiltersCount: number = 0;
  @Input() IsFiltersVisible: boolean = false;
  @Input() hasFooter: boolean = true;
  @Input() hasTitle: boolean = false;
  @Input() title: string = "";
  @Input() hasSeeBtn: boolean = false;
  @Input() seeBtnTitle: string = "";
  showDropDown = false;
  // add button properties
  @Input() hasAddBtn: boolean = false;
  @Input() addBtnLabel: string;
  @Input() ImportUsersBtnLabel:string
  @Input() popperMessage: string;
  isAddAllowed: boolean = true;
  isAllowedImportUsers: boolean = true;
  @Input()
  public set addBtnPermission(permission: number) {
    this.isAddAllowed = !!this.permissionsService.getPermission(permission);
  }
  @Input() public set importUsersBtnPermission(permission: number) {
    this.isAllowedImportUsers = !!this.permissionsService.getPermission(permission);
  }
  handleDropdown() {
    this.showDropDown = !this.showDropDown;
    window.dispatchEvent(new Event("resize"));
  }

  // export button properties
  @Input() hasExportBtn: boolean = false;
  @Input() hasReminderBtn: boolean = false;
  @Input() hasImportResultsBtn: boolean = false;
  @Input() isDownloading: boolean = false;
  @Output() onImportBtnCLicked = new EventEmitter();
  @Output() search: EventEmitter<string> = new EventEmitter();
  @Output() onSwitch: EventEmitter<boolean> = new EventEmitter();
  @Output() onSwitchMainTasksEmitter: EventEmitter<boolean> = new EventEmitter();
  @Output() onSearchBtnCLicked = new EventEmitter();
  @Output() onCancel = new EventEmitter();
  @Output() onClear = new EventEmitter();
  @Output() onOpenAdvancedFilterModel = new EventEmitter();
  @Output() onAddBtnCLicked = new EventEmitter();




  @Output() onExportBtnClicked = new EventEmitter();
  @Output() onSendReminderBtnClicked = new EventEmitter();
  @Output() onImportResultsBtnClicked = new EventEmitter();
  @Output() onTreeExpanded = new EventEmitter();
  @Output() onViewModeChange = new EventEmitter();
  @Output() onSeeBtnClicked = new EventEmitter();

  appliedCountAppeared: boolean = false;
  isShowSendPermissionButton: boolean = !!this.permissionsService.getPermission(
    Permissions.EmployeeAppraisal.planning.showSendReminder,
  );

  constructor(private permissionsService: NgxPermissionsService, private eRef: ElementRef) {
  }

  ngOnInit(): void {
  }

  ngOnChanges() {
    this.appliedCountAppeared = this.appliedFiltersCount > 0 ? true : false;
    this.IsFiltersVisible ? down(this.advancedFilterContent.nativeElement) : "";
  }

  // toggle advanced filter content visibility
  toggleContentVisibility() {
    if (this.popupAdvancedFilter) {
      this.onOpenAdvancedFilterModel.emit();
    } else {
      toggle(this.advancedFilterContent.nativeElement);
    }
  }

  // close advanced filter content
  closeContentVisibility() {
    up(this.advancedFilterContent.nativeElement);
  }

  ClearFilter() {
    this.onClear.emit();
    this.appliedCountAppeared = false;
  }

  inportUserBtnClicked() {
    this.onImportBtnCLicked.emit();
  }

  onSwitchChange(status: boolean) {
    this.onSwitch.emit(status);
  }

  onSwitchMainTasks(status: boolean) {
    this.onSwitchMainTasksEmitter.emit(status);
  }


  onSearch(searchString: string) {
    this.search.emit(searchString);
  }

  searchBtnClicked() {
    this.onSearchBtnCLicked.emit();
  }

  addBtnClicked() {
    this.onAddBtnCLicked.emit();
  }
  seeBtnClicked() {
    this.onSeeBtnClicked.emit();
  }

  exportBtnClicked() {
    this.onExportBtnClicked.emit();
  }

  sendReminderBtnClicked() {
    this.onSendReminderBtnClicked.emit();
  }

  importResults() {
    this.onImportResultsBtnClicked.emit();
  }

  changeViewMode(mode) {
    this.viewMode = mode;
    this.onViewModeChange.emit(this.viewMode);
  }

  toggleTreeExpanding() {
    this.isTreeExpanded = !this.isTreeExpanded;
    this.onTreeExpanded.emit(this.isTreeExpanded);
  }
}
